import { ECONTRACT_STATUS } from "../../../../enums";
import { CONTRACT_BASE_URL } from "../../../constants";
import { getToken, isLoggedIn } from "../../../context/authContext";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { CONTRACT_PATH } from "./constants";
import {
  IContractActionsResponse,
  IContractDetailsBody,
  IContractDetailsResponse,
  IContractListResponse,
  IUpdateContractRequestBody,
} from "./models";

const appProvide = async () => AuthConfig.getAppToken();
const defaultProvide = async () => await getToken();

export const getContractDetails = (
  id: string
): Promise<IContractDetailsResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}`,
    "GET",
    isLoggedIn() ? defaultProvide : appProvide
  );
  return fetchRequest(descriptor, null);
};

interface CotractProps {
  listType: string;
  status?: string;
  contractId?: string;
  createdAtTo?: Date | null | string;
  createdAtFrom?: Date | null | string;
  page: number;
  size: number;
}

export const getContracts = ({
  listType = "active",
  status = "",
  contractId = "",
  createdAtTo = "",
  createdAtFrom = "",
  page = 0,
  size = 10,
}: CotractProps): Promise<IContractListResponse> => {
  const statusFilter = prepareStatusFilter(listType);
  const sort = "updatedAt,desc";
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}?contractId=${contractId}&status=${
    status !== "" && status !== "ALL_CASES" ? status : statusFilter
  }&createdAtTo=${createdAtTo}&createdAtFrom=${createdAtFrom}&page=${page}&size=${size}&sort=${sort}`;

  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

const prepareStatusFilter = (listType: string) => {
  if (listType === "active") {
    const activeStatusList = [
      ECONTRACT_STATUS.CREATED,
      ECONTRACT_STATUS.WAITING_FOR_DELIVERY,
      ECONTRACT_STATUS.ITEM_INSPECTION,
      ECONTRACT_STATUS.DELIVERY_ESCALATION,
      ECONTRACT_STATUS.INSPECTION_ESCALATION,
      ECONTRACT_STATUS.PAID,
      ECONTRACT_STATUS.WAITING_FOR_SHIPMENT,
      ECONTRACT_STATUS.ITEM_ACCEPTED,
      ECONTRACT_STATUS.WAITING_FOR_APPROVAL,
      ECONTRACT_STATUS.CONTRACT_ACCEPTED,
      ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER,
      ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER,
      ECONTRACT_STATUS.CANCELED,
    ];
    return activeStatusList.join();
  } else {
    const previousStatusList = [
      ECONTRACT_STATUS.COMPLETED,
      ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER,
      ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER,
    ];
    return previousStatusList.join();
  }
};

interface PublicCotractProps {
  senderId: string;
  page: number;
  size: number;
}

export const getPublicContracts = ({
  senderId = "",
  page = 0,
  size = 10,
}: PublicCotractProps): Promise<IContractListResponse> => {
  const sort = "updatedAt,desc";
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/sender/${senderId}?page=${page}&size=${size}&sort=${sort}`;

  const descriptor = new ApiServiceManager(url, "GET", appProvide);
  return fetchRequest(descriptor);
};

export const createContractDetails = (
  body: IContractDetailsBody
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const editContractDetails = (
  body: IContractDetailsBody,
  contractId: string
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${contractId}`;
  const descriptor = new ApiServiceManager(url, "PUT", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const deleteContractById = (id: number | string) => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}`;
  const descriptor = new ApiServiceManager(url, "DELETE", defaultProvide);
  return fetchRequest(descriptor, null);
};

export const cloneContractById = (id: number | string) => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}/clone`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, null);
};

export const getContractByUrl = (
  clientURL: string
): Promise<IContractDetailsResponse> => {
  const body = {
    clientURL: clientURL,
    clientId: 1,
  };
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/populate`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const updateContractById = (
  id: string,
  body: IUpdateContractRequestBody
) => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}/item-details`;
  const descriptor = new ApiServiceManager(url, "PATCH", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const getContractActions = (
  id: string
): Promise<IContractActionsResponse> => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}/actions`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor, null);
};
